import TPL = require("templates");
import {Config} from "../config";

export class HostMessageController {

  static eventId;
  private eventId;
  public emailText;
  private hostData;

  scope = {
    params: "=params"
  };
  link;

  static $inject = ["session", "$uibModalInstance", "$log", "$route", "Notification"];

  constructor(
    public session,
    private modalInstance,
    private log,
    private route,
    private notification
  ) {

    this.eventId = this.session.getData().event.uuid;

    this.hostData = {
      avatar: this.session.getData().event.created_by_profile.avatar,
      first_name: this.session.getData().event.created_by_profile.first_name,
      last_name: this.session.getData().event.created_by_profile.last_name,
      email: [this.session.getData().event.created_by_profile.email]
    }

    this.session.loadEvent(this.eventId);
    this.session.loadReservations(this.eventId);
  }

  sendMessage(form) {
    if (form.$valid) {
        this.hostData.email;
        this.emailText;
        if(this.hostData.email) {
          this.session.sendInvitations("guest-message",this.hostData.email, this.emailText).then(() => {
            this.notification.success("The message has been sent!");
            this.modalInstance.dismiss();
          });
        }
    }
  }

isValidEmail (value) {
    if (!value) {
        return false;
    }
    // Email Regex used by ASP.Net MVC
    var regex = /^[\w-]+(\.[\w-]+)*@([a-z0-9-]+(\.[a-z0-9-]+)*?\.[a-z]{2,6}|(\d{1,3}\.){3}\d{1,3})(:\d{4})?$/i;
    return regex.exec(value) != null;
}

  static open(modal, eventId) {

    HostMessageController.eventId = eventId;

    return modal.open({
      controller: HostMessageController,
      controllerAs: "vm",
      replace: true,
      size: "md",
      template: TPL.modals.hostMessage
    });
  }
}



/** WEBPACK FOOTER **
 ** ./src/scripts/modals/hostMessage.ts
 **/